import { platformRows } from '@/mocks/homeMock';

export default function SpeedRank() {
  return (
    <section id="speed" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="grid gap-10 lg:grid-cols-5 lg:gap-12">
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
            <i className="ri-scales-3-line" />
            SPEED RANKING
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">全网平台速度排行</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            同一个瓜，谁先落地、谁讲得更全？我们以分钟为单位横向对比各大内容平台的
            <span className="font-semibold text-primary-600">首发延迟</span>与
            <span className="font-semibold text-accent-700">信息深度</span>，帮你在追瓜路上少走弯路。
          </p>

          <div className="mt-6 rounded-2xl border border-background-200 bg-background-100 p-5">
            <h3 className="text-sm font-bold text-foreground-900">综合评分规则</h3>
            <ul className="mt-3 space-y-2 text-xs text-foreground-600 md:text-sm">
              <li className="flex items-center gap-2"><i className="ri-timer-line text-primary-500" />首发延迟：事件落地到被大众触达的时间差</li>
              <li className="flex items-center gap-2"><i className="ri-speed-up-line text-accent-600" />传播速度：热度爬升速率与覆盖面</li>
              <li className="flex items-center gap-2"><i className="ri-loop-left-line text-secondary-600" />更新轮次：事件持续发酵后的跟进频率</li>
              <li className="flex items-center gap-2"><i className="ri-database-2-line text-foreground-700" />信源完整：内容深度与背景梳理程度</li>
            </ul>
          </div>

          <div className="mt-6 flex items-center gap-3 rounded-2xl bg-foreground-950 p-5 text-background-50">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-500 text-foreground-950">
              <i className="ri-cup-line text-xl" />
            </span>
            <div>
              <p className="text-xs text-background-200">综合第一名</p>
              <p className="font-heading text-lg font-black text-accent-300">短视频热榜 · 96 分</p>
              <p className="text-xs text-background-300">追突发瓜最快的首选入口</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
            <div className="hidden grid-cols-12 gap-2 border-b border-background-200 bg-background-100 px-5 py-3 text-xs font-semibold text-foreground-500 md:grid">
              <span className="col-span-4">平台类型</span>
              <span className="col-span-2">首发延迟</span>
              <span className="col-span-2">深度分</span>
              <span className="col-span-4">综合评分</span>
            </div>

            {platformRows.map((p) => (
              <div key={p.name} className="grid grid-cols-12 gap-2 border-b border-background-100 px-5 py-4 transition hover:bg-background-100/60 last:border-0">
                <div className="col-span-12 md:col-span-4">
                  <div className="flex items-center gap-3">
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                      <i className="ri-wifi-line" />
                    </span>
                    <div>
                      <p className="text-sm font-bold text-foreground-900">{p.name}</p>
                      <p className="text-xs text-foreground-500">更新频率：{p.update}</p>
                    </div>
                  </div>
                </div>
                <div className="col-span-12 flex items-center gap-2 md:col-span-2 md:flex-col md:items-start md:justify-center">
                  <span className="md:hidden text-xs text-foreground-500">首发延迟</span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-2.5 py-0.5 text-xs font-semibold text-primary-600">
                    <i className="ri-time-line" />
                    {p.delay}
                  </span>
                </div>
                <div className="col-span-12 flex items-center gap-3 md:col-span-2 md:flex-col md:justify-center">
                  <span className="md:hidden text-xs text-foreground-500">深度分</span>
                  <div className="h-2 w-full overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-accent-500" style={{ width: `${p.depth}%` }} />
                  </div>
                </div>
                <div className="col-span-12 flex items-center justify-between md:col-span-4 md:flex-col md:items-end md:gap-1 md:justify-center">
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading text-2xl font-black text-primary-600">{p.score}</span>
                    <span className="text-xs text-foreground-400">/ 100</span>
                  </div>
                  <p className="text-xs text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}